import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenService } from '../services/token.service';

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {
  constructor(private service: TokenService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    const clonedReq = request.clone({
      url: request.url,
      setHeaders: {
        Authorization: `Bearer ${this.service.token.get()}`,
        'Access-Control-Allow-Headers': 'authorization',
        'Access-Control-Allow-Origin': '*'
      },
    });

    return next.handle(clonedReq);
  }
}
